import { useMemo, useCallback } from 'react';
import { AudioPlayerButton } from 'components/PlayerButton';
import BackButton from 'components/BackButton';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import useAudioContext from 'services/hooks/wavesurfer';
import {
  DurationSection,
  TitleSection,
  ActionButtonsSection,
} from './components';
import {
  MiniPlayerContainer,
  PlaybackSection,
  WaveformSection,
  WaveformSkeleton,
  Waveform,
} from './styled';

type Props = {
  hidden: boolean;
};

const MiniPlayer = ({ hidden = false }: Props) => {
  const { isLoading, song, updateContainerRef, changeSong } = useAudioContext();

  const isHidden = useMemo(() => hidden || !song, [hidden, song]);

  const onWaveformContainerRefChange = useCallback(
    (containerRef) => {
      if (!containerRef) {
        return;
      }
      updateContainerRef(containerRef);
    },
    [updateContainerRef]
  );

  const handleClose = useCallback(() => {
    changeSong(null);
  }, [changeSong]);

  return (
    <MiniPlayerContainer isMiniPlayerHidden={isHidden}>
      <PlaybackSection>
        <AudioPlayerButton
          song={song}
          location={AnalyticsEventLocation.MINI_AUDIO_PLAYER}
        />
        <TitleSection />
      </PlaybackSection>
      <WaveformSection>
        <DurationSection />
        {isLoading && <WaveformSkeleton variant="rectangular" />}
        <Waveform
          sx={{ ...(isLoading && { display: 'none' }) }}
          ref={onWaveformContainerRefChange}
        />
      </WaveformSection>
      <ActionButtonsSection songId={song?.id ?? ''} />
      <BackButton handleClose={handleClose} />
    </MiniPlayerContainer>
  );
};

export default MiniPlayer;
